if (!customElements.get('ht-pla-early-bird-teaser')) {
  customElements.define('ht-pla-early-bird-teaser', class HtPlaEarlyBirdTeaser extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;
      this.countdownEl = this.querySelector('[data-ht-pla-countdown]');
      this.unitPriceEls = this.querySelectorAll('[data-ht-pla-unit-price]');
      this.endTime = this.parseEndTime();
      this.prefix = this.countdownEl ? this.countdownEl.dataset.countdownPrefix : '';
      this.variantPrice = Number(this.dataset.currentVariantPrice || 0);

      if (Number.isNaN(this.endTime.getTime())) {
        this.hideBlock();
        return;
      }

      this.updateCountdown();
      this.countdownTimer = window.setInterval(() => this.updateCountdown(), 1000);
      this.variantChangeHandler = this.handleVariantChange.bind(this);
      document.addEventListener('on:variant:change', this.variantChangeHandler);
    }

    disconnectedCallback() {
      window.clearInterval(this.countdownTimer);
      document.removeEventListener('on:variant:change', this.variantChangeHandler);
      this.isInitialized = false;
    }

    handleVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant || variant.price == null) return;

      this.variantPrice = Number(variant.price);
      this.dataset.currentVariantId = variant.id;
      this.dataset.currentVariantPrice = variant.price;
      this.updateUnitPrices();
    }

    updateCountdown() {
      const remaining = this.endTime.getTime() - Date.now();

      if (remaining <= 0) {
        this.hideBlock();
        window.clearInterval(this.countdownTimer);
        return;
      }

      this.showBlock();
      if (!this.countdownEl) return;

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.countdownEl.textContent = `${this.prefix} ${days}${this.countdownEl.dataset.dayUnit} ${this.pad(hours)}${this.countdownEl.dataset.hourUnit} ${this.pad(minutes)}${this.countdownEl.dataset.minuteUnit} ${this.pad(seconds)}${this.countdownEl.dataset.secondUnit}`;
    }

    updateUnitPrices() {
      this.unitPriceEls.forEach((priceEl) => {
        const percent = Number(priceEl.dataset.percent || 0);
        const discountedPrice = Math.round(this.variantPrice * (100 - percent) / 100);
        priceEl.textContent = this.formatMoney(discountedPrice);
      });
    }

    parseEndTime() {
      const endDate = (this.dataset.endDate || '').trim();
      const rawTime = (this.dataset.endTime || '').trim();
      const timezone = this.normalizeTimezone(this.dataset.endTimezone || '');
      if (!endDate || !rawTime || !timezone) return new Date(NaN);

      const time = rawTime.length === 2 ? `${rawTime}:00:00` : rawTime.length === 5 ? `${rawTime}:00` : rawTime;
      return new Date(`${endDate}T${time}${timezone}`);
    }

    normalizeTimezone(value) {
      const timezone = value.trim().replace(/^UTC/i, '');
      const match = timezone.match(/^([+-])(\d{1,2})(?::?(\d{2}))?$/);
      if (!match) return '';

      const sign = match[1];
      const hours = match[2].padStart(2, '0');
      const minutes = match[3] || '00';
      return `${sign}${hours}:${minutes}`;
    }

    hideBlock() {
      this.hidden = true;
      const block = this.closest('.product-info__block--ht-pla-early-bird');
      if (block) block.hidden = true;
    }

    showBlock() {
      this.hidden = false;
      const block = this.closest('.product-info__block--ht-pla-early-bird');
      if (block) block.hidden = false;
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        if (this.dataset.moneyFormat) return window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
      }).format(cents / 100);
    }

    pad(value) {
      return String(value).padStart(2, '0');
    }
  });
}
